module.exports = __webpack_public_path__ + "img/records1.d048a0e7.webp";